export class Attendance {
    ID: number
    CLIENT_ID: number
    EMPLOYEE_ID: number
    IN_LOCATION: string
    IN_DISTANCE: string
    OUT_LOCATION: string
    OUT_DISTANCE: string
}